export * from "./block-templates-convert";

export const name = "block-templates";
